import { Badge, Group, Table, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

type PlanNameCellProps = {
  name: string;
  isDefault: boolean;
};

export const PlanNameCell = ({ name, isDefault }: PlanNameCellProps) => {
  const { t } = useTranslation();

  return (
    <Table.Td>
      <Group gap="xs" wrap="nowrap">
        <Text size="sm" fw={500}>
          {name}
        </Text>
        {isDefault && (
          <Badge variant="light" radius="sm" size="sm">
            {t(i18nKeys.SETTINGS.WORKFLOWS.DEFAULT)}
          </Badge>
        )}
      </Group>
    </Table.Td>
  );
};
